import React, { useEffect, useState } from "react";
import ModalBasic from "../../components/infrastructure/Modals/ModalBasic";
import { useFormik } from "formik";
import FormikInputGroup from "../../components/formik/FormikInputGroup";
import FormikSelectGroup from "../../components/formik/FormikSelectGroup";
import FormikInputDateGroup from "../../components/formik/FormikInputDateGroup";
import FormikTime from "../../components/formik/FormikTime";
import PrimaryButton from "../../components/infrastructure/Buttons/PrimaryButton";
import FormikTextareaGroup from "../../components/formik/FormikTextareaGroup";
import moment from "moment";
import * as Yup from "yup";
import { CALENDER_TYPE } from "../../utils/dropdownOptions";
import { authAxiosInstance } from "../../utils/axiosConfig";
import { toast } from "react-toastify";
import { Calendar, Clock, Phone, User } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomerContact, fetchCustomers, getCustomer } from "../../app/reducers/Customer/customerSlice";
import { customIDs } from "../../utils/validators/customIds";
import ThankYouPage from "./ThankYouPage";
import { useNavigate } from "react-router-dom";

const EventForm = ({
  isModalOpen,
  setIsModalOpen,
  timeSlotData,
  fetchEventsForCustomer,
  setClickedIndex,
  decryptPhone,
}) => {
  console.log('data', timeSlotData)
  const { customers, loading } = useSelector(getCustomer);
  const [callerData, setCallerData] = useState(null);
  console.log('customers',customers)
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const computeInitialValue = (data) => {
    if (data) {
      const startTime = moment(
        `${moment(data?.selectedDate).format("YYYY-MM-DD")} ${data?.timeSlot}`,
        "YYYY-MM-DD h:mma"
      ).valueOf();
      const endTime = moment(startTime).add(15, "minutes").valueOf();

      return {
        title: "",
        type: "meeting",
        start: startTime,
        end: endTime,
        startTime: startTime,
        endTime: endTime,
        priority: 10,
        allDay: false,
        description: "",
      };
    } else {
      return {
        title: "",
        type: "meeting",
        start: null,
        end: null,
        startTime: "",
        endTime: "",
        priority: 10,
        allDay: false,
        description: "",
      };
    }
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: computeInitialValue(timeSlotData),
    validationSchema: Yup.object({
      scheduleBy: Yup.string().label("Name").required(),
    }),
    onSubmit: async (values) => {
      console.log("values", values);
      const newStart = moment(values.startTime).toDate();
      const newEnd = moment(values.endTime).toDate();
      const obj = {
        ...values,
        title: `Schedule Me - ${callerData?.company_name ? callerData?.company_name : 'Unknown'}-${callerData?.mobile ? callerData?.mobile : decryptPhone}`,
        start: newStart,
        end: newEnd,
      };
      try {
        const resp = await authAxiosInstance.post(
          `/calenderEvent/customerSchedule`,
          obj
        );
        console.log('resp', resp)
        if (resp?.data?.success) {
          fetchEventsForCustomer(timeSlotData.selectedDate);
          setClickedIndex(null);
          // toast.success("Event Scheduled");
          navigate(`/thankYou/${resp?.data?.data?._id}`)
        }
      } catch (error) {
        console.log("Error", error);
        toast.error("Failed to scheduled event");
      }
      setIsModalOpen(false);
    },
  });
  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  useEffect(()=>{
    const phone = decryptPhone.slice(2);

    const query = {
      // contact_type: 'customer',
      // phone_contains : phone
      cf_vendor_mobile_number : phone
    }
    // query[`custom_field_${customIDs.vendor_mobile}_contains`] = phone
    dispatch(fetchCustomerContact(query))
  },[decryptPhone])

  useEffect(()=>{
    if(customers && customers?.contacts?.length){
      setCallerData(customers?.contacts[0]);
    }
  },[customers])
  
  return (
    <ModalBasic
      modalOpen={isModalOpen}
      setModalOpen={setIsModalOpen}
      title={"Enter Details"}
    >
      <form onSubmit={formik.handleSubmit} className="flex flex-col gap-4 p-4">
        <h1 className="text-center text-xl">15 Minute Meeting</h1>
        <p className="flex flex-row gap-1 items-center text-stone-500">
          <Clock size={18} className="mr-1" /> 15 min
        </p>
        <p className="flex flex-row gap-1 items-center text-stone-500">
          <Phone size={18} className="mr-1" /> Phone call
        </p>
        <p className="flex flex-row gap-1 items-center text-stone-500">
          <Calendar size={22} className="mr-1" />{" "}
          {`${formatTime(formik.values.startTime)} - ${formatTime(
            formik.values.endTime
          )}, ${moment(formik.values.start).format("dddd, MMMM D, YYYY")}`}
        </p>
        <p className="flex flex-row gap-1 items-center text-stone-500">
          <User size={20} className="mr-1" />
          <span>{callerData?.company_name ? callerData?.company_name : 'Unknown'}-{callerData?.mobile ? callerData?.mobile : decryptPhone}</span>
        </p>
        {/* <div className="flex flex-col md:flex-row items-center gap-4">
          <div className="w-full">
            <FormikInputGroup formik={formik} label="Title" name="title" required />
          </div>
          <div className="w-full">
            <FormikInputGroup
              formik={formik}
              label="Type"
              name="type"
              readOnly
            />
          </div>
        </div>
        <div className="flex flex-col md:flex-row items-center gap-4">
          <div className="w-full">
            <FormikInputDateGroup
              formik={formik}
              label="Start"
              name="start"
              readOnly
            />
          </div>
          <div className="w-full">
            <FormikInputDateGroup formik={formik} label="End" name="end" readOnly />
          </div>
        </div>
        <div className="flex flex-col md:flex-row items-center gap-4">
          <div className="w-full">
            <FormikTime
              formik={formik}
              label="Start Time"
              name="startTime"
              readOnly
            />
          </div>
          <div className="w-full">
            <FormikTime
              formik={formik}
              label="End Time"
              name="endTime"
              readOnly
            />
          </div>
        </div> */}
        <div className="flex flex-col items-center gap-4">
          <div className="w-full">
            <FormikInputGroup
              formik={formik}
              label="Name"
              name="scheduleBy"
              required
            />
          </div>
          <div className="w-full">
            <FormikTextareaGroup
              formik={formik}
              label="मीटिंग की तैयारी हेतु जानकारी दें। ताकि हम सही जानकारी दे सकें"
              name="description"
            />
          </div>
        </div>
        <div className="mt-4">
          <PrimaryButton type="submit">Schedule Event</PrimaryButton>
        </div>
      </form>
    </ModalBasic>
  );
};

export default EventForm;
